<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { computed } from 'vue'
import { cn } from '@/lib/utils'

interface CardProps {
  class?: HTMLAttributes['class']
  variant?: 'default' | 'plain'
  hideOnMobile?: boolean
}

const props = withDefaults(defineProps<CardProps>(), {
  variant: 'default',
  hideOnMobile: false,
})

const variantClasses = {
  default: 'rounded-xl bg-gradient-putih p-4 shadow-stats-container',
  plain: 'rounded-xl bg-card text-card-foreground border p-4 shadow-xs',
}

const cardClasses = computed(() => {
  return cn(
    variantClasses[props.variant],
    props.hideOnMobile && 'card-hide-on-mobile',
    props.class,
  )
})
</script>

<template>
  <div
    data-slot="card"
    :class="cardClasses"
  >
    <slot />
  </div>
</template>

<style scoped>
@media (max-width: 639px) {
  .card-hide-on-mobile {
    all: unset;
  }
}
</style>
